import request from '../../utils/request';

export default {
	list(data) {
		return request({
			url: "/todo-list",
			method: 'get',
			params: data
		})
	},
	createQuotationApply(data){
		return request({
			url: "/todo-list?action=createQuotationApply",
			method: 'put',
			params: data
		})
	}
}
